<template>
    <div :class="{[wrapperClass]: true}" v-if="!hidden">
        <nav :class="{[navClass]: true}">
        <ul :class="{[mainClass]: true}" v-if="tabs.length>0">
            <li v-for="tab in tabs" 
                :key="tab.id" 
                class="tab" 
                :class="{
                    'tab-disabled': tab.disabled,
                    'tab-selected': tab.id == selectedTabId
                }">
                <a href="javascript: void 0" v-i18n="tab.title" @click="changeTab(tab.id)" />
                <small v-if="tab.label" v-i18n="tab.label" class="hg-badge"/>
            </li>
        </ul>
        </nav>
        <slot />
    </div>
</template>
<script>
export default {
    props: {
        defaultTabId: {type: String},
        mainClass: {type: String, default: "hg-tabs"},
        wrapperClass: {type: String, default: "hg-tabs-wrapper"},
        navClass: {type: String, default: "top-subnavbar"}
    },
    mounted(){
        this.check();
        this.computeHash();
    },
    data(){
        return {
            tabNodes: [],
            tabs: [],
            hidden: false,
            selectedTabId: this.defaultTabId
        }
    },
    watch: {
        "$route.hash": function(){
            this.computeHash();
        }
    },
    methods:{
        computeHash: function(){
            if( !!this.$route.hash && 
                typeof this.$route.hash == "string" && 
                this.$route.hash != "#")
            this.selectedTabId = this.$route.hash.replace("#","");
            this.changeTab(this.selectedTabId, true);
        },
        check: function(){
            var self = this;
            this.tabNodes = this.$el.querySelectorAll(".tab");
            if(this.tabNodes.length == 0){
                this.hidden = true;
                return;
            }
            this.hidden = false;
            var _map = function(tab){ 
                return {
                    id: tab.id, 
                    title: tab.getAttribute('hg-title'),
                    disabled: tab.getAttribute('disabled'),
                    label: tab.getAttribute('label')
                }; 
            }
            this.tabs = Array.prototype.map.call(this.tabNodes, _map);
            if(!this.tabs.find(function(x){ return x.id == self.defaultTabId; }))
                this.selectedTabId = this.tabs[0].id;
        },
        changeTab: function(tabid, avoidhash){
            if(!avoidhash)
                this.$router.push({hash: tabid});
            this.tabNodes.forEach(function(n){
                n.style.display = (n.id==tabid)?'block':'none';
            })
            this.$emit("input", tabid)
            this.selectedTabId = tabid;
        }
    }
}
</script>